export const findObjectStartsWithKey = (key, object) => {
  if (object == null) {
    return null;
  }

  var obj = null;
  object.traverse((child) => {
    if (child.name.startsWith(key)) {
      obj = child;
    }
  });
  return obj;
};

export const findAllObjectsStartsWithKey = (key, object) => {
  if (object == null) {
    return [];
  }

  var objs = [];
  object.traverse((child) => {
    if (child.name.startsWith(key)) {
      objs.push(child);
    }
  });
  return objs;
};

export const findChildStartsWithKey = (key, object) => {
  if (object == null) {
    return null;
  }

  var obj = object.children.find((child) => child.name.startsWith(key));
  return obj;
};
